import type { AppAgg, CauseAgg } from './utils';
import { cityOf, failRate, fmtDec, fmtInt, hasCause, rateTone } from './utils';
import { CauseChips } from './CauseChips';
import { CauseMix } from './CauseMix';
import s from './BroadcastDetailsModal.module.css';

interface Props {
  apps: AppAgg[];
  causes: CauseAgg[];
  cause: string | null;
  onCause: (k: string | null) => void;
  openApps: Set<number>;
  onToggleApp: (app: number) => void;
  appName: (id: number) => string;
}

export function DistributionTab({ apps, causes, cause, onCause, openApps, onToggleApp, appName }: Props) {
  return (
    <div className={s.distTab}>
      <div className={s.chipBar}><CauseChips causes={causes} active={cause} onChange={onCause} /></div>
      <div className={s.scroll}>
        <div className={`${s.distGrid} ${s.tHead} ${s.sticky}`}>
          <span /><span>App</span><span className={s.right}>Pág.</span><span className={s.right}>Leads</span><span className={s.right}>Enviados</span><span className={s.right}>Falhas</span><span>Causas</span>
        </div>
        {apps.length === 0 && <div className={s.empty}>Nenhum app encontrado</div>}
        {apps.map((a) => {
          const open = openApps.has(a.app), t = rateTone(a.rate);
          return (
            <div key={a.app} className={s.distBlock}>
              <button type="button" className={`${s.distGrid} ${s.distRow}`} style={{ background: open ? '#fafbfc' : undefined }} onClick={() => onToggleApp(a.app)} aria-expanded={open}>
                <span className={s.muted}>{open ? '▾' : '▸'}</span>
                <span className={s.nameCell}><b>{appName(a.app)}</b><small>#{a.app}</small></span>
                <span className={s.right}>{a.pages.length}</span>
                <span className={s.right}>{fmtInt(a.leads)}</span>
                <span className={`${s.right} ${s.blue}`}>{fmtInt(a.sent)}</span>
                <span className={s.failRate}><b>{fmtInt(a.fail)}</b><span style={{ background: t.bg, color: t.fg }}>{fmtDec(a.rate)}%</span></span>
                <CauseMix errs={a.errs} active={cause} />
              </button>
              {open && (
                <div className={s.distSub}>
                  {[...a.pages].sort((x, y) => y.fail - x.fail).map((p) => {
                    const r = failRate(p.fail, p.leads), pt = rateTone(r);
                    return (
                      <div key={p.id} className={`${s.distGrid} ${s.distSubRow}`} style={{ opacity: cause && !hasCause(p, cause) ? 0.3 : 1 }}>
                        <span />
                        <span className={s.subName}>{p.name}</span>
                        <span className={`${s.right} ${s.tiny}`}>{cityOf(p.tz)}</span>
                        <span className={s.right}>{fmtInt(p.leads)}</span>
                        <span className={`${s.right} ${s.blue}`}>{fmtInt(p.sent)}</span>
                        <span className={s.failRate}><span className={s.red}>{fmtInt(p.fail)}</span><span style={{ background: pt.bg, color: pt.fg }}>{fmtDec(r)}%</span></span>
                        <CauseMix errs={p.errs} active={cause} small />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
